<div class="mb-[30px]">
  <h2 class="app w-full mb-2">{{data.businessName}} - {{data.policyNumber}}</h2>
  <p class="mb-4">Please make any updates to optional forms and coverage and review price increase. If no additional changes submit endorsement request.</p>
  <section class="flex flex-col">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-[35px]">
      <div class="price-bg">
        <div>
          <h4 class="mb-4">General Liability Policy Totals</h4>
          <div class="space-y-2">
            <div class="flex justify-between border-bottom">
              <span class="text-sm  text-gray-600">Rated Premium Increase</span>
              <span>{{ wizardStore.quoteBreakdown()?.additionalPremium | currency }}</span>
            </div>
            <div class="flex justify-between border-bottom">
              <span class="text-sm  text-gray-600">Surplus Lines Tax</span>
              <span>{{ wizardStore.quoteBreakdown()?.surplusLinesTax | currency }}</span>
            </div>
            <div class="flex justify-between border-bottom">
              <span class="text-sm  text-gray-600">Stamping Office Fee</span>
              <span>{{ wizardStore.quoteBreakdown()?.stampingFee | currency }}</span>
            </div>
          </div>
        </div>
        <div class="mt-6 flex items-center justify-between price-indication-wrapper">
          <div class="flex items-center">
            <h3 class="app">Total Price Increase</h3>
          </div>
          <ng-container *ngIf="wizardStore.quoteBreakdown()?.totalPrice > 0; else noIncrease">
            <h3 class="app">{{ wizardStore.quoteBreakdown()?.totalPrice | currency: 'USD':'symbol':'1.2-2' }}</h3>
          </ng-container>
          <ng-template #noIncrease>
            <h3 class="app">No Additional Premium</h3>
          </ng-template>
        </div>
      </div>
      <div class="bg-white shadow-md rounded-lg p-6">
        <h4 class="text-lg font-semibold mb-2">Optional Forms & Coverages</h4>
        <p class="text-sm text-gray-500 mb-5">
          Toggle options below to update the price indication.
        </p>
        <div class="space-y-3">
          @for (endorsement of wizardStore.endorsementList(); track endorsement; let i = $index) {
          <div class="flex items-center">
            <lib-form-toggle [value]="endorsement.code"
              [isChecked]="wizardStore.endorsements?.()?.includes(endorsement.code!)!"
              (checked)="wizardStore.updateEndorsements($event.value, $event.checked, true)"
              [disabled]="wizardStore.disabledEndorsements().includes(endorsement.code!) || disableReQuote()"></lib-form-toggle>
            <span>{{ endorsement.title }}</span>
            <lib-info-hover [content]="endorsement.description!" class="ml-4"></lib-info-hover>
          </div>
          }
        </div>
      </div>
    </div>
    <div class="px-3 mt-[40px]">
      <h3 class="app secondary-heading primary-color">Summary of Changes</h3>
      <div class="mb-6" *ngIf="wizardStore.quoteBreakdown()">
        <div *ngIf="wizardStore.quoteBreakdown()?.summaryOfChanges?.quoteChanges!.length > 0">
          <h5 class="mt-[30px]">Address, Contacts, Operations, and Pricing Factor</h5>
          <div *ngFor="let change of wizardStore.quoteBreakdown()?.summaryOfChanges!.quoteChanges" class="m-b-10">
            <p>
              {{ change.fieldName }}: Updated from <strong>{{ change.previousValue ?? "0" }}</strong> to
            <strong>{{ change.newValue ?? "0" }}</strong>
            </p>
          </div>
        </div>
        <div *ngIf="wizardStore.quoteBreakdown()?.summaryOfChanges?.classChanges!.length > 0">
          <h5 class="mt-[30px]">Classifications</h5>
          <div *ngFor="let change of wizardStore.quoteBreakdown()?.summaryOfChanges?.classChanges" class="m-b-10">
            <p>
              {{ change.description }} (<strong>{{change.classCode}}</strong>):
              @if (change.classChangeType === 'Removed') {
              <strong>Removed</strong>
              } @else {
              Updated from <strong>{{ change.previousPayroll ?? "0" }}</strong> to <strong>{{change.newPayroll ?? "0"
                }}</strong>
              }
            </p>
          </div>
        </div>
        <div *ngIf="wizardStore.quoteBreakdown()?.summaryOfChanges?.endorsementChanges!.length > 0">
          <h5 class="mt-[30px]">Endorsements</h5>
          <div *ngFor="let change of wizardStore.quoteBreakdown()?.summaryOfChanges?.endorsementChanges" class="m-b-10">
            <p>{{ change.name }}: <strong>{{change.formNumber }}</strong></p>
          </div>
        </div>
        <div *ngIf="wizardStore.quoteBreakdown()?.summaryOfChanges?.formChanges!.length > 0">
          <h5 class="mt-[30px]">Optional Forms & Coverages</h5>
          <div *ngFor="let change of wizardStore.quoteBreakdown()?.summaryOfChanges?.formChanges" class="m-b-10">
            <p>
              {{ change.formName }}: <strong>{{change.formNumber }}</strong> - <strong>{{change.formChangeType}}</strong>
            </p>
          </div>
        </div>
      </div>
      <form [formGroup]="form()!" class="mt-[30px]">
        <div class="flex flex-col gap-3">
          <div class="flex flex-row items-center">
            <lib-custom-date-picker class="w-1/2" label="Requested Endorsement Effective Date"
              formControlName="endorsementEffectiveDate"></lib-custom-date-picker>
          </div>
        </div>
      </form>
    </div>
  </section>
</div>